import React from "react";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  Selection,
} from "devextreme-react/data-grid";
import Form, {
  SimpleItem,
  Label,
  GroupItem,
  EmptyItem,
  ButtonItem,
} from "devextreme-react/form";
import UserInfo from "../../UserInfo";
import uiInfo from "../../ui-info";
import { Button } from "devextreme-react";
import axiosApi from "../../api-axios";
import openReport from "../../openReport";
import showError from "../../AppServices";
import { criarPrecoPublicoDs } from "../../DataSources";
import List from "devextreme-react/list";
import { TabPanel, Item } from "devextreme-react/tab-panel";
import { LoadIndicator } from "devextreme-react/load-indicator";

const data = new Date();

export default class FaturamentoPermissionarios extends React.Component {
  constructor() {
    super();
    this.state = {
      prefeituraId: UserInfo.getPrefeitura(),
      mes: data.getMonth() + 1,
      ano: data.getFullYear(),
      vencimento: data,
      precosPublicos: [],
      faturamentoPrecos: [],
      linhasSelecionadas: [],
      etapa: 0,
      dams: [],
      damsSelecionados: [],
      _msgCarregando: ""
    };
    this.calcular = this.calcular.bind(this);
    this.lancar = this.lancar.bind(this);
    this.pesquisar = this.pesquisar.bind(this);
    this.imprimir = this.imprimir.bind(this);
    this.onSelectionDams = this.onSelectionDams.bind(this);
    this.onSelection = this.onSelection.bind(this);
    this.precoPublicoDs = criarPrecoPublicoDs();

    this.precosPublicosOptions = {
      editorType: "dxTagBox",
      selectionMode: "multiple",
      searchEnabled: false,
      dataSource: this.precoPublicoDs,
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: true,
    };
  }

  calcular() {

    this.setState({ _msgCarregando: "Calculando..." });

    console.log(this.state);

    const stateData = this.state;

    const req = {
      ano: stateData.ano,
      mes: stateData.mes,
      vencimento: stateData.vencimento,
      precosPublicos: stateData.precosPublicos
    };

    axiosApi
      .post(`precopublico/calcular/${this.state.prefeituraId}`, req)
      .then((response) => {
        if (response !== undefined) {
          this.setState({ faturamentoPrecos: response.data });
          console.log("response:", response.data);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          showError(error.response.data);
        } else {
          showError(error);
        }
      })
      .finally(() => {
        this.setState({ _msgCarregando: "" })
      });
  }

  lancar() {

    this.setState({ _msgCarregando: "Lançamento permissionários, por favor aguarde!" });

    const req = {
      ano: this.state.ano,
      mes: this.state.mes,
      vencimento: this.state.vencimento,
      linhasSelecionadas: this.state.linhasSelecionadas,
    };

    axiosApi
      .post(`precopublico/lancar/${this.state.prefeituraId}`, req)
      .then((response) => {
        if (response !== undefined && response.status === 200) {
          this.setState({ etapa: 1, dams: [], damsSelecionados: [] });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          showError(error.response.data);
        } else {
          showError(error);
        }
      })
      .finally(() => {
        this.setState({ _msgCarregando: "" })
      });
  }

  pesquisar() {

    this.setState({ _msgCarregando: "Pesquisando lançamentos, por favor aguarde!" })

    const req = {
      ano: this.state.ano,
      mes: this.state.mes,
      precosPublicos: this.state.precosPublicos,
    };

    console.log("req pesquisar", req);

    axiosApi
      .post(`precopublico/pesquisarimpressao/${this.state.prefeituraId}`, req)
      .then((response) => {
        if (response !== undefined) {
          this.setState({ dams: response.data });
          console.log("response:", response.data);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          showError(error.response.data);
        } else {
          showError(error);
        }
      })
      .finally(() => {
        this.setState({ _msgCarregando: "" })
      });
  }

  imprimir() {

    this.setState({ _msgCarregando: "Imprimindo DAM's, por favor aguarde!" });

    axiosApi
      .post(`precopublico/imprimir/${this.state.prefeituraId}`, this.state.damsSelecionados)
      .then((response) => {
        openReport(response.data);
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          showError(error.response.data);
        } else {
          showError(error);
        }
      })
      .finally(() => {
        this.setState({ _msgCarregando: "" });
      });
  }

  onSelection(e) {
    if (e !== undefined) {
      this.setState({
        linhasSelecionadas: e.selectedRowsData,
      });
    }
  }

  onSelectionDams(e) {
    if (e !== undefined) {
      this.setState({
        damsSelecionados: e.selectedRowsData,
      });
    }
  }

  render() {

    if (this.state._msgCarregando != undefined && this.state._msgCarregando != "") {
      return (
        <div className={"content-block dx-card responsive-paddings"}>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column"
            }}
          >
            <LoadIndicator width={60} height={60} />
            <h3>{this.state._msgCarregando}</h3>
          </div>
        </div>
      );
    }

    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <TabPanel
          selectedIndex={this.state.etapa}
          onOptionChanged={(e) => {
            if (e.name === "selectedIndex") this.setState({ etapa: e.value });
          }}
        >
          <Item title="CALCULAR" >
            <div style={{ margin: "30px" }}>
              <h3>
                {this.state.etapa === 0
                  ? "CALCULAR PERMISSIONÁRIOS"
                  : "PESQUISAR DAMS DOS PERMISSIONÁRIOS"}
              </h3>
              <form>
                <Form
                  id="frmPesquisa"
                  formData={this.state}
                  colCount={5}
                  labelLocation={"top"}
                >
                  <SimpleItem
                    dataField="mes"
                    colSpan={1}
                    editorType={"dxSelectBox"}
                    editorOptions={{
                      editorType: "dxSelectBox",
                      dataSource: uiInfo.listaMeses,
                      displayExpr: "mes",
                      valueExpr: "id",
                    }}
                  >
                    <Label text="Mês" />
                  </SimpleItem>
                  <SimpleItem
                    dataField="ano"
                    colSpan={1}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      value: this.state.ano,
                      step: 0,
                    }}
                  >
                    <Label text="Ano" />
                  </SimpleItem>


                  <SimpleItem dataField={"precosPublicos"}
                    colSpan={2}
                    editorType="dxTagBox"
                    editorOptions={this.precosPublicosOptions}
                    helpText={"Deixe em branco para todos ou selecione o que desejar"}>
                    <Label text="Preços Públicos" />
                  </SimpleItem>

                  <SimpleItem
                    dataField="vencimento"
                    editorType="dxDateBox"
                    editorOptions={{ width: "100%", useMaskBehavior: true }}
                    colSpan={1}
                  >
                    <Label text="Vencimento" />
                  </SimpleItem>
                  <EmptyItem colSpan={3} />
                  <ButtonItem
                    buttonOptions={{ text: "Calcular", width: "100%", type: "success", onClick: this.calcular }}
                    verticalAlignment={"bottom"} />
                  <ButtonItem
                    buttonOptions={{ text: "Lançar", width: "100%", type: "default", onClick: this.lancar, disabled: this.state.linhasSelecionadas.length == 0 }}
                    verticalAlignment={"bottom"} />

                </Form>
              </form>
              <br />
              <div
                style={{
                  display:
                    this.state.faturamentoPrecos.length > 0 &&
                      this.state.etapa === 0
                      ? ""
                      : "none",
                }}
              >
                <h3>Faturamentos</h3>
                <DataGrid
                  dataSource={this.state.faturamentoPrecos}
                  showBorders={true}
                  rowAlternationEnabled={true}
                  remoteOperations={true}
                  columnAutoWidth={true}
                  wordWrapEnabled={window.innerWidth < 800}
                  onSelectionChanged={(e) => this.onSelection(e)}
                >
                  <Selection
                    mode="multiple"
                    selectAllMode="allPages"
                    showCheckBoxesMode="always"
                  />

                  <Column dataField={"contribuinte"} caption={"Contribuinte"} />
                  <Column dataField={"boxLoja"} caption={"Box/Loja"} />
                  <Column dataField={"unidadeCalculo"} caption={"Unid. Medida"} width={110} />

                  <Column dataField={"baseCalculo"} format={uiInfo.formatoNumerico.n2} caption={"Base Cálculo"} width={100} />
                  <Column dataField={"precoPublico"} caption={"Preço Público"} />
                  <Column dataField={"total"} caption={"Total (R$)"} format={uiInfo.formatoNumerico.n2} width={120} />



                  <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                  />
                </DataGrid>
              </div>

            </div>
          </Item>
          <Item title="PESQUISAR DAMS">
            <div style={{ margin: "30px" }}>
              <h3>
                {this.state.etapa === 0
                  ? "CALCULAR PERMISSIONÁRIOS"
                  : "PESQUISAR DAMS DOS PERMISSIONÁRIOS"}
              </h3>
              <form>
                <Form
                  id="frmPesquisa"
                  formData={this.state}
                  colCount={5}
                  labelLocation={"top"}
                >
                  <SimpleItem
                    dataField="mes"
                    colSpan={1}
                    editorType={"dxSelectBox"}
                    editorOptions={{
                      editorType: "dxSelectBox",
                      dataSource: uiInfo.listaMeses,
                      displayExpr: "mes",
                      valueExpr: "id",
                    }}
                  >
                    <Label text="Mês" />
                  </SimpleItem>
                  <SimpleItem
                    dataField="ano"
                    colSpan={1}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      value: this.state.ano,
                      step: 0,
                    }}
                  >
                    <Label text="Ano" />
                  </SimpleItem>


                  <SimpleItem dataField={"precosPublicos"}
                    colSpan={3}
                    editorType="dxTagBox"
                    editorOptions={this.precosPublicosOptions}
                    helpText={"Deixe em branco para todos ou selecione o que desejar"}>
                    <Label text="Preços Públicos" />
                  </SimpleItem>

                  <EmptyItem colSpan={3} />
                  <ButtonItem
                    buttonOptions={{ text: "Pesquisar", width: "100%", type: "success", onClick: this.pesquisar }}
                    verticalAlignment={"bottom"} />
                  <ButtonItem
                    buttonOptions={{ text: "Imprimir", width: "100%", type: "default", onClick: this.imprimir, disabled: this.state.damsSelecionados.length == 0 }}
                    verticalAlignment={"bottom"} />

                </Form>
              </form>
              <br />
              <div
                style={{
                  display:
                    this.state.dams.length > 0 && this.state.etapa === 1
                      ? ""
                      : "none",
                }}
              >
                <h3>DAMs</h3>
                <DataGrid
                  dataSource={this.state.dams}
                  showBorders={true}
                  rowAlternationEnabled={true}
                  remoteOperations={true}
                  columnAutoWidth={true}
                  wordWrapEnabled={window.innerWidth < 800}
                  onSelectionChanged={(e) => this.onSelectionDams(e)}
                >
                  <Selection mode="multiple" selectAllMode="allPages" showCheckBoxesMode="always" />

                  <Column dataField={"damSeq"} caption={"#"} width={"80"} alignment={"center"} />
                  <Column dataField={"contribuinte"} caption={"Contribuinte"} />
                  <Column dataField={"boxLoja"} caption={"Box/Loja"} />
                  <Column dataField={"baseCalculo"} caption={"Base Cálculo"} />
                  <Column dataField={"total"} caption={"Total"} />
                  <Column dataField={"precoPublico"} caption={"Total"} />


                  <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                  />
                </DataGrid>
              </div>
            </div>
          </Item>

        </TabPanel>
      </div>
    );
  }
}
